module.exports = __webpack_public_path__ + "static/img/8.f093185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/8.png
// module id = Y+6Q
// module chunks = 0